const TOTAL_WORK_HOURS = '[data-tour="reports-total-work-hours-report"]';
const WORK_HOURS_SUMMARY = '[data-tour="reports-work-hours-summary-report"]';
const PRODUCTIVITY = '[data-tour="reports-productivity-report"]';
const USER_DETAILS = '[data-tour="reports-user-details-report"]';
const EXPORT_BTN = '[data-tour="reports-export-button"]';
const FILTER_INPUT = '[data-tour="reports-filter-input"]';
const TABLE = '[data-tour="reports-table"]';

const goToHub = () => {
  window.__backToReportsHub?.();
};

/** Mở Total Work Hours (id=0) để hiện Export / Filter / Table */
const openTotalWorkHoursReport = () => {
  window.__openReport?.(0);
};

// Trả về steps theo hàm để hỗ trợ i18n
export const getReportsTourSteps = (t) => [
  {
    selector: '[data-tour="drawer-reports"]',
    content: t("tour.reports.drawer"),
  },
  {
    selector: TOTAL_WORK_HOURS,
    content: t("tour.reports.total-work-hours-report"),
    tourOpen: goToHub,
    tourWaitFor: TOTAL_WORK_HOURS,
    tourWaitFrames: 1,
    tourScrollBlock: "start",
  },
  {
    selector: WORK_HOURS_SUMMARY,
    content: t("tour.reports.work-hours-summary-report"),
    tourOpen: goToHub,
    tourWaitFor: WORK_HOURS_SUMMARY,
    tourWaitFrames: 1,
  },
  {
    selector: PRODUCTIVITY,
    content: t("tour.reports.productivity-report"),
    tourOpen: goToHub,
    tourWaitFor: PRODUCTIVITY,
    tourWaitFrames: 1,
  },
  {
    selector: USER_DETAILS,
    content: t("tour.reports.user-details-report"),
    tourOpen: goToHub,
    tourWaitFor: USER_DETAILS,
    tourWaitFrames: 1,
  },
  {
    selector: EXPORT_BTN,
    content: t("tour.reports.export-button"),
    tourOpen: openTotalWorkHoursReport,
    tourWaitFor: EXPORT_BTN,
    tourWaitFrames: 1,
    tourStableFrames: 2,
    tourScrollBlock: "start",
    mutationObservables: [EXPORT_BTN],
    resizeObservables: [EXPORT_BTN],
  },
  {
    selector: FILTER_INPUT,
    content: t("tour.reports.filter-input"),
    tourOpen: openTotalWorkHoursReport,
    tourWaitFor: FILTER_INPUT,
    tourWaitFrames: 1,
    tourStableFrames: 2,
    mutationObservables: [FILTER_INPUT],
    resizeObservables: [FILTER_INPUT],
  },
  {
    selector: TABLE,
    content: t("tour.reports.table"),
    tourOpen: openTotalWorkHoursReport,
    tourWaitFor: TABLE,
    tourWaitFrames: 1,
    tourStableFrames: 2,
    mutationObservables: [TABLE],
    resizeObservables: [TABLE],
  },
];
